import { APPLICATION_BANK_STATUS } from "./types";

// Получить список разрешенных статусов
export const getStatusesWithoutDisabled = (
  disabledStatuses: APPLICATION_BANK_STATUS[]
) => {
  const allStatuses = Object.values(APPLICATION_BANK_STATUS);
  return allStatuses.filter((status) => !disabledStatuses.includes(status));
};
